import React, { useMemo } from "react";
import classNames from "classnames";
import Alert from "@/components/atoms/Alert";

interface SimpleMessageProps {
  className?: string;
  content: string;
}

const SimpleMessage: React.FC<SimpleMessageProps> = ({ className, content }) => (
  <div
    className={className}
    dangerouslySetInnerHTML={{ __html: content }}
  />
);

interface CustomAlertProps {
  className?: string;
  content: string;
  showIcon?: boolean;
}

const CustomAlert: React.FC<CustomAlertProps> = ({ className, content, showIcon }) => (
  <Alert
    className={className}
    type="warning"
    showLeftIcon={showIcon}
    content={content}
  />
);

const SuccessAlert: React.FC<CustomAlertProps> = ({ className, content, showIcon }) => (
  <Alert
    className={className}
    type="success"
    showLeftIcon={showIcon}
    content={content}
  />
);

const TypeMessage = {
  error: SimpleMessage,
  helper: SimpleMessage,
  disclaimerBeforeField: CustomAlert,
  disclaimerAfterField: CustomAlert,
  disclaimerAlert: CustomAlert,
  successNote: SuccessAlert,
} as const;

type MessageType = keyof typeof TypeMessage;

interface MessageComponentProps {
  content?: string;
  type: MessageType;
  showIcon?: boolean;
}

const MessageComponent: React.FC<MessageComponentProps> = ({ content, type, showIcon }) => {
  const className = classNames({
    "input-error": type === "error",
    "input-helper": type === "helper",
    "formField-disclaimer formField-disclaimer--before-field": type === "disclaimerBeforeField",
    "formField-disclaimer formField-disclaimer--after-field": type === "disclaimerAfterField",
    "formField-disclaimer formField-disclaimer--alert": type === "disclaimerAlert",
    "formField-success-note": type === "successNote",
  });

  const Message = useMemo(() => TypeMessage[type], [type]);

  return content && content.length > 0 ? (
    <Message
      className={className}
      content={content}
      showIcon={showIcon}
    />
  ) : null;
};

export default MessageComponent;
